module.exports = __webpack_public_path__ + "img/curva.ae31d245.svg";